import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const AnonymousIcon: React.FunctionComponent<IconProps> = ({
  width = 60,
  height = 60,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxHeight={60} viewBoxWidth={60} {...rest}>
    <path d="M30 0C13.44 0 0 13.44 0 30C0 46.56 13.44 60 30 60C46.56 60 60 46.56 60 30C60 13.44 46.56 0 30 0ZM30 9C34.98 9 39 13.02 39 18C39 22.98 34.98 27 30 27C25.02 27 21 22.98 21 18C21 13.02 25.02 9 30 9ZM30 51.6C22.5 51.6 15.87 47.76 12 41.94C12.09 35.97 24 32.7 30 32.7C35.97 32.7 47.91 35.97 48 41.94C44.13 47.76 37.5 51.6 30 51.6Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/anonymous.icon.tsx